import Jsona from 'jsona'

const dataFormatter = new Jsona()

// Request middleware that transforms body params into JSON:API structure.
function serializeBody({ body, type }) {
  if (!body) return
  if (!type) throw new Error('Type required for JSON:API transformation')
  return {
    body: dataFormatter.serialize({
      // Yes, the argument is actually "stuff"...
      stuff: { type, ...body },
    }),
  }
}

export default serializeBody
